





























































import Vue from 'vue'
import { mapGetters } from 'vuex';
import { getAppointmentDetails, getSupervisorData, getTeamMembers } from '@/api';
import { EventType, Routes } from '@/constants';
import { Appointment, Member, SupervisorData, User } from '@/types';
import { formatInTimeZone, getPhaseCompletionStatus, getPhaseIcon, hideLoader, isApptEditable, showLoader } from '@/util';
import { bus } from '@/main';

export default Vue.extend({
  components: {
    EditIcon: () => import('@/assets/icons/Edit.vue'),
    DeleteIcon: () => import('@/assets/icons/Delete.vue')
  },
  props: {
    appointmentId: {
      type: String,
      required: true
    },
    prevScreen: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      appointment: {} as Appointment,
      appointmentDataExists: false,
      Routes,
      EventType
    }
  },
  mounted () {
    document.body.classList.add('overflow-hidden');
    this.fetchAppointmentDetails();
  },
  computed: {
    ...mapGetters(['isLoggedInAsAdmin', 'mileStones', 'selectedJob']),
    isEditable (): boolean {
      return this.appointment.appointmentStartTime ? isApptEditable(this.appointment.appointmentStartTime, this.appointment.isFromFeedAppointment, this.appointment.appointmentType.customerCanScheduleAppointment) : false;
    }
  },
  methods: {
    async fetchActiveTeamMembers () {
      const response = await getTeamMembers(this.selectedJob);
      const data = response.members as Member[];
      return data.filter((member) => member.status.toLowerCase() === 'active').map((teamMember) => teamMember.userId.toString());
    },
    async navigate () {
      if (process.env.VUE_APP_SHOW_MESSAGE !== 'true') {
        return;
      }
      this.$emit(EventType.CLOSE_MODAL);
      showLoader();
      const teamMemberId = this.appointment.teamMember.teamMemberId;
      const activeTeamMembers = await this.fetchActiveTeamMembers();
      if (teamMemberId && activeTeamMembers.includes(teamMemberId.toString())) {
        this.$router.push({
          name: Routes.TEAM_MEMBER_MESSAGE,
          params: {
            teamMemberId
          }
        });
      } else if (teamMemberId && !activeTeamMembers.includes(teamMemberId.toString())) {
        let supervisorId;
        const response = await getSupervisorData(+teamMemberId);
        hideLoader();
        if (response) {
          const supervisorData = response as SupervisorData;
          supervisorId = supervisorData.memberId.toString();
          this.$emit(EventType.CLOSE_MODAL);
          this.$router.push({
            name: Routes.TEAM_MEMBER_MESSAGE,
            params: {
              teamMemberId: supervisorId
            }
          });
        }
      } else {
        this.$router.push({ name: Routes.MESSAGES });
      }
      hideLoader();
    },
    async fetchAppointmentDetails () {
      showLoader();
      this.appointment = (await getAppointmentDetails(this.appointmentId)).appointment;
      const appointmentType = this.appointment.appointmentType;
      this.appointment.appointmentType = {
        ...appointmentType,
        allowDivisionTeamMembers: !!appointmentType.allowDivisionTeamMembers,
        buffer: appointmentType.buffer || +process.env.VUE_APP_APPOINTMENT_BUFFER_CONFIG
      };
      this.appointmentDataExists = true;
      hideLoader();
    },
    formatSlot (slot: Date | string) {
      return formatInTimeZone(slot, 'h:mm a');
    },
    formatDate (date: string) {
      const initial = date.split('/');
      return [initial[1], initial[0], initial[2]].join('/');
    },
    modifyAppointment (appointment: Appointment) {
      if (!this.isLoggedInAsAdmin) {
        this.$emit(EventType.CLOSE_MODAL);
        this.$router.push({
          name: Routes.MODIFY_APPOINTMENT,
          params: {
            appointmentTypeId: appointment.appointmentType.appointmentTypeId
          },
          query: {
            appointmentId: appointment.appointmentId,
            prev: this.prevScreen
          }
        });
      } else {
        bus.$emit(EventType.VIEW_VERSION);
      }
    },
    getStageStatus (value: string) {
      const data = this.mileStones[value];
      const status = data?.status?.stage;
      return getPhaseCompletionStatus(status);
    },
    getPhaseIcon (phase: string) {
      return getPhaseIcon(phase);
    }
  },
  destroyed () {
    document.body.classList.remove('overflow-hidden');
  }
});
